import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Icon } from "@iconify/react";

import { IconButton, Tooltip } from "@mui/material";

import { DataGrid, gridClasses } from "@mui/x-data-grid";

import "./CallMonitoring.css";
import {
  getCallMonitoring,
  monitoringAction,
} from "../Store/Actions/MonitoringAction";
import { START_CALL, UPDATE_CALL_STATE } from "../Store/Types/CallTypes";
import { stateAction } from "../Store/Actions/AuthAction";

const CallMonitoring = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const { myInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchData = () => {
      getCallMonitoring(myInfo.user.AgentID)
        .then((response) => {
          if (response.status) {
            console.log("Call monitor data: ", response.data);
            setData(response.data);
          } else {
            console.log("error", response.error);
          }

          setIsLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsLoading(false);
        });
    };

    // Fetch data on first render
    fetchData();

    // Fetch data every one second
    const interval = setInterval(() => {
      fetchData();
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleMonitoringAction = (type, destinationExt, sourceExt, phoneNo) => {
    monitoringAction(type, destinationExt, sourceExt)
      .then((response) => {
        if (response.status) {
          console.log("Monitoring action data: ", response.data);

          dispatch({
            type: START_CALL,

            payload: {
              phoneNumber: phoneNo,
              goToACW: false,
            },
          });

          dispatch({
            type: UPDATE_CALL_STATE,
            payload: { stateCode: "6" },
          });

          dispatch(stateAction("BUSY", undefined, "READY", "Red"));
        } else {
          console.log("error", response.error);
        }

        setIsLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  };

  const columns = [
    {
      field: "AgentCode",
      flex: 1,
      headerName: "Agent Code",
    },

    {
      field: "AgentName",
      flex: 1,
      headerName: "Agent Name",
    },

    {
      field: "Ext",
      flex: 1,
      headerName: "Ext",
      maxWidth: 60,
    },

    {
      field: "StateDesc",
      flex: 0.55,
      headerName: "State Desc",
    },

    {
      field: "StateDuration",
      flex: 1,
      headerName: "State Duration",
      maxWidth: 130,
      // renderCell: (params) =>
      //   moment.utc(params.row.stateDuration).format("HH:mm:ss"),
    },

    {
      field: "PhoneNo",
      flex: 1,
      headerName: "Phone No",
      // maxWidth: 130,
    },

    {
      field: "CallTime",
      flex: 0.5,
      headerName: "Call Time",
    },

    {
      field: "AnswerTime",
      flex: 0.65,
      headerName: "Answer Time",
    },

    {
      field: "action",
      flex: 1,
      headerName: "Action",

      renderCell: (params) => {
        return (
          <>
            <Tooltip title="Silent monitor" arrow>
              <IconButton
                onClick={() =>
                  handleMonitoringAction(
                    "silentmonitor",
                    params.row.Ext,
                    myInfo.user.Ext,
                    params.row.PhoneNo
                  )
                }
              >
                <Icon height="30" icon="carbon:hearing" width="30" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Coaching" arrow>
              <IconButton
                onClick={() =>
                  handleMonitoringAction(
                    "coaching",
                    params.row.Ext,
                    myInfo.user.Ext,
                    params.row.PhoneNo
                  )
                }
              >
                <Icon height="30" icon="mdi:teacher" width="30" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Barge in" arrow>
              <IconButton
                onClick={() =>
                  handleMonitoringAction(
                    "bargein",
                    params.row.Ext,
                    myInfo.user.Ext,
                    params.row.PhoneNo
                  )
                }
              >
                <Icon
                  height="30"
                  icon="fluent:people-queue-20-filled"
                  width="30"
                />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <DataGrid
      autoPageSize
      className="call-monitoring table"
      columns={columns}
      disableColumnFilter
      disableColumnMenu
      disableSelectionOnClick
      loading={isLoading}
      rows={data}
      sx={{
        [`& .${gridClasses.cell}`]: {
          py: 1.8,
        },
      }}
      getRowClassName={() => "row"}
      getRowId={(row) => row.AgentCode + "-" + row.Ext}
    />
  );
};

export default CallMonitoring;
